// src/components/FriendItem.js

import React from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "./avatars";
import styles from "./FriendItem.module.css";

const FriendItem = ({ friend, onClick }) => {
  const { t } = useTranslation();
  const handleFriendClick = () => onClick(friend.id);

  const getDisplayName = () =>
    friend.displayName || friend.username || t("friends.anonymous_friend");

  return (
    <li
      className={styles.friendItem}
      onClick={handleFriendClick}
      onKeyPress={(e) =>
        (e.key === "Enter" || e.key === " ") && handleFriendClick()
      }
      role="button"
      tabIndex="0"
    >
      <div className={styles.friendAvatar}>
        <Avatar
          name={getDisplayName()}
          src={friend.photoURL}
          size="fluid"
          alt={t("friends.profile_picture_alt", { name: getDisplayName() })}
          textColor="var(--background-elevated)"
        />
      </div>
      <div className={styles.friendInfo}>
        <div className={styles.friendName}>{getDisplayName()}</div>
        {friend.username && (
          <div className={styles.friendUsername}>@{friend.username}</div>
        )}
      </div>
    </li>
  );
};

export default FriendItem;
